// eslint-disable-next-line no-shadow
export enum SORT_TYPE {
  ASC = 'ASC', DESC = 'DESC'
}

// eslint-disable-next-line no-shadow
export enum VALIDATION_RULE {
  IS_NOT_EMPTY, IS_EMAIL, IS_LONGER, IS_PHONE, IS_LINK, IS_IMAGE_LINK, CONTAINS_CAPITAL, CONTAINS_SPECIAL, CONTAINS_NUMERIC,
  CONTAINS_SPECIAL_OR_NUMERIC, IS_VALID_CODE, CONTAINS_REG_CODE, IS_HTTPS
}

// eslint-disable-next-line no-shadow
export enum USER_STATUS {
  UNKNOWN,
  CONFIRM_EMAIL,
  SETUP_EXCHANGE,
  LOGGED_IN,
  COMPLETED,
  NOT_REGISTERED,
  CONFIRM_PHONE_NUMBER,
}

// eslint-disable-next-line no-shadow
export enum NAVIGATION_PAGES {
  SPACES_CONTACTS = 'SPACES_CONTACTS',
  SPACES_ADD_CONTACTS = 'SPACES_ADD_CONTACTS',
  SPACES_GROUPS = 'SPACES_GROUPS',
  SPACES_MANAGE = 'SPACES_MANAGE',
  SPACES_GROUP_INFO = 'SPACES_GROUP_INFO',
  SPACES_GROUP_SETTINGS = 'SPACES_GROUP_SETTINGS',
  SPACES_GROUP_MEMBERS = 'SPACES_GROUP_MEMBERS',
  SPACES_GROUP_NAME = 'SPACES_GROUP_NAME',
  NETWORK = 'NETWORK',
  NETWORK_PHOTOS = 'NETWORK_PHOTOS',
  NETWORK_FILES = 'NETWORK_FILES',
  NETWORK_CASES = 'NETWORK_CASES',
  PUBLIC_CASES = 'PUBLIC_CASES',
  MY_PUBLIC_CASES = 'MY_PUBLIC_CASES',
  USER_PUBLIC_CASES = 'USER_PUBLIC_CASES',
  DRIVE = 'DRIVE',
  DRIVE_PHOTOS = 'DRIVE_PHOTOS',
  DRIVE_FILES = 'DRIVE_FILES',
  DRIVE_CASES = 'DRIVE_CASES',
  DRIVE_FOLDER = 'DRIVE_FOLDER',
  CASE_EDIT = 'CASE_EDIT',
  CASE_VIEW = 'CASE_VIEW',
  CASE_CREATE = 'CASE_CREATE',
  HOME = 'HOME',
  ALERTS = 'ALERTS',
  SETTINGS = 'SETTINGS',
  PAYMENT = 'PAYMENT',
  PROFILE_MY = 'PROFILE_MY',
  PROFILE_FOREIGN = 'PROFILE_FOREIGN',
  SPACES_SETTLE = 'SPACES_SETTLE',
  SPACES_GROUPS_MAIN = 'SPACES_GROUPS_MAIN',
  SPACES_GROUPS_OVERVIEW = 'SPACES_GROUPS_OVERVIEW',
  SPACES_GROUPS_EDIT = 'SPACES_GROUPS_EDIT',
  MESSAGES_MY = 'MESSAGES_MY',
  MESSAGES_ID = 'MESSAGES_ID',
  MESSAGES_GROUP_CHAT_ID = 'MESSAGES_GROUP_CHAT_ID',
}

// eslint-disable-next-line no-shadow
export enum CONTACT_STATUS {
  ACCEPTED = 'ACCEPTED',
  NO_CONTACT = 'NO_CONTACT',
  REQUEST_SENT = 'REQUEST_SENT',
  REQUEST_RECEIVED = 'REQUEST_RECEIVED',
  CONTACT = 'CONTACT',
  PENDING = 'PENDING',
  DELETED = 'DELETED',
  REJECTED = 'REJECTED'
}

// eslint-disable-next-line no-shadow
export enum GROUP_STATUS {
  NO_CONTACT = 'NO_CONTACT',
  REQUEST_SENT = 'REQUEST_SENT',
  REQUEST_RECEIVED = 'REQUEST_RECEIVED',
  CONTACT = 'CONTACT',
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
  IN_GROUP_ACCEPTED = 'IN_GROUP_ACCEPTED',
  IN_GROUP_REJECTED = 'IN_GROUP_REJECTED',
  IN_GROUP_PENDING = 'IN_GROUP_PENDING',
}

// eslint-disable-next-line no-shadow
export enum REGISTRATION_GROUP {
  ADD_NAME, ADD_INFO, ADD_SETTINGS, ADD_MEMBERS,
}

// eslint-disable-next-line no-shadow
export enum NETWORK_CONTACT_TYPES {
  INVITATION,
  SUGGESTION,
  OUTCOMING,
  MY,
  MANAGE,
  GROUP_INVITATION,
  GROUP_MANAGE,
  ME,
  GROUP_REQUESTS,
  GROUP_INVITE_REQUEST,
  IN_GROUP_REQUEST
}

// eslint-disable-next-line no-shadow
export enum REGISTRATION_STATE {
  CONFIRM_EMAIL = 'CONFIRM_EMAIL',
  SETUP_EXCHANGE = 'SETUP_EXCHANGE',
  COMPLETED = 'COMPLETED',
  NOT_REGISTERED = 'NOT_REGISTERED',
  CONFIRM_PHONE_NUMBER = 'CONFIRM_PHONE_NUMBER',
}

// eslint-disable-next-line no-shadow
// export enum PASSWORD_RECOVER_STEP {
//   STEP_1 = 'RESET_FORM', STEP_2 = 'RESET_RESPONSE'
// }

// eslint-disable-next-line no-shadow
export enum ACCOUNT_STATUS {
  REGISTERED = 'REGISTERED',
  PREMIUM = 'PREMIUM',
  CORPORATE_ACCOUNT = 'CORPORATE_ACCOUNT',
  SUB_ACCOUNT = 'SUB_ACCOUNT',
  BETA = 'BETA',
  DEFAULT_USER = 'DEFAULT_USER',
  CONFIRMED = 'CONFIRMED',
  PHONE_NUMBER_CONFIRMED = 'PHONE_NUMBER_CONFIRMED',
}

// eslint-disable-next-line no-shadow
export enum MEDIA_TYPES {
  PHOTO = 'PHOTO', FILES = 'FILE', VIDEO = 'VIDEO'
}

// eslint-disable-next-line no-shadow
export enum REQUEST_DIRECTION {
  INCOMING, OUTCOMING
}

// eslint-disable-next-line no-shadow
export enum REQUEST_TYPE {
  GROUP_INVITE_REQUEST = 'GROUP_INVITE_REQUEST',
  IN_GROUP_REQUEST = 'IN_GROUP_REQUEST',
}

// eslint-disable-next-line no-shadow
export enum CASE_VIEW_NAVIGATION {
  OVERVIEW, COMMENTS, FILES
}

// eslint-disable-next-line no-shadow
export enum BOTTOM_POPUP_TYPES {
  COMMENTS, UPLOAD_FILES, UPLOAD_CASE, UPLOAD_VIDEOS,
  UPLOAD_PHOTOS, UPLOAD_ALL, UPLOAD_FOLDER,
  PHOTO_INFO_OLD, PHOTO_INFO, FILE_INFO, FILE_INFO_OLD, CASE_INFO,
}

// eslint-disable-next-line no-shadow
export enum SHARE_TYPES {
  CASE, PHOTO, FILE, FOLDER
}

// eslint-disable-next-line no-shadow
export enum CASE_SHARE_POPUP_STATES {
  MENU, SHARE_BY_NETWORK, SHARE_BY_MESSAGE
}

// eslint-disable-next-line no-shadow
export enum NOTIFICATION_TYPE {
  CONTACT_REQUEST_SENT = 'CONTACT_REQUEST_SENT',
  CONTACT_REQUEST_ACCEPT = 'CONTACT_REQUEST_ACCEPT',
  CONTACT_REQUEST_REJECT = 'CONTACT_REQUEST_REJECT',
  GROUP_REQUEST_SENT = 'GROUP_REQUEST_SENT',
  GROUP_REQUEST_ACCEPT = 'GROUP_REQUEST_ACCEPT',
  GROUP_REQUEST_REJECT = 'GROUP_REQUEST_REJECT',
  IN_GROUP_REQUEST_SENT = 'IN_GROUP_REQUEST_SENT',
  IN_GROUP_REQUEST_ACCEPT = 'IN_GROUP_REQUEST_ACCEPT',
  IN_GROUP_REQUEST_REJECT = 'IN_GROUP_REQUEST_REJECT',
  ADDED_TO_GROUP = 'ADDED_TO_GROUP',
  REMOVED_FROM_GROUP = 'REMOVED_FROM_GROUP',
  USER_LEFT_THE_GROUP = 'USER_LEFT_THE_GROUP',
  SHARE_FILE = 'SHARE_FILE',
  SHARE_CASE = 'SHARE_CASE',
  SHARE_FOLDER = 'SHARE_FOLDER',
}

// eslint-disable-next-line no-shadow
export enum NOTIFICATION_STATUS {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

// eslint-disable-next-line no-shadow
export enum NOTIFICATION_READ_MODE {
  BY_ID = 'BY_ID',
  BY_TYPE = 'BY_TYPE',
  MIXED = 'MIXED',
}

// eslint-disable-next-line no-shadow
export enum HIDE_BORDER {
  TOP, BOTTOM, ALL, NONE
}

// eslint-disable-next-line no-shadow
export enum BADGES_TYPES {
  ALERTS = 'ALERTS',
  MESSAGES = 'MESSAGES',
  REQUESTS = 'REQUESTS',
  CONTACT_REQUESTS = 'CONTACT_REQUESTS',
  GROUP_REQUESTS = 'GROUP_REQUESTS',
  IN_GROUP_REQUESTS = 'IN_GROUP_REQUESTS',
}

// eslint-disable-next-line no-shadow
export enum SEND_MESSAGE_ACTIONS {
  SEND = 'SEND', // for msg
  READ = 'READ', // for msg
  DELETE = 'DELETE', // for msg
  UPDATE_BADGE = 'UPDATE_BADGE',
  // eslint-disable-next-line no-shadow
  GROUP_STATUS = 'GROUP_STATUS',
  // eslint-disable-next-line no-shadow
  CONTACT_STATUS = 'CONTACT_STATUS',
  SHARE = 'SHARE',
  NO_SHARE = 'NO_SHARE',
  GROUP_UPDATED = 'GROUP_UPDATED',
  USER_JOIN_IN_GROUP = 'USER_JOIN_IN_GROUP',
  USER_LEFT_THE_GROUP = 'USER_LEFT_THE_GROUP',
  USER_STATUS_IN_THE_GROUP_UPDATED = 'USER_STATUS_IN_THE_GROUP_UPDATED',
  GROUP_DELETED = 'GROUP_DELETED',
  FILE_UPLOADED = 'FILE_UPLOADED',
  AVATAR_CHANGED = 'AVATAR_CHANGED',
  SHARED_DRIVE_FILE_SAVED = 'SHARED_DRIVE_FILE_SAVED',
  SHARED_DRIVE_CASE_SAVED = 'SHARED_DRIVE_CASE_SAVED',
  SHARED_DRIVE_FOLDER_SAVED = 'SHARED_DRIVE_FOLDER_SAVED',
  NEW_ALERT = 'NEW_ALERT',
}

// eslint-disable-next-line no-shadow
export enum ENCODING_TYPES {
  CURRENT_CASE_PHOTO, CURRENT_CASE_FILES,
  ALL_PHOTO, ALL_FILES,
}

// eslint-disable-next-line no-shadow
export enum SHARE_ACCESS {
  SPECIFIC_PEOPLE = 'SPECIFIC_PEOPLE',
  GROUP = 'GROUP',
  EVERYONE = 'EVERYONE',
  EXCLUDED_PEOPLE = 'EXCLUDED_PEOPLE'
}

// eslint-disable-next-line no-shadow
export enum CREATE_STEPS {
  NAME = 'STEP_NAME',
  INFO = 'STEP_INFO',
  SETTING = 'STEP_SETTING',
  ADD = 'STEP_ADD',
}

// eslint-disable-next-line no-shadow
export enum FOLDER_TYPES {
  CASE_FOLDER = 'CASE_FOLDER',
  NON_CASE_FOLDER = 'NON_CASE_FOLDER',
}

// eslint-disable-next-line no-shadow
export enum USER_TYPE {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  USER = 'USER',
}

// eslint-disable-next-line no-shadow
export enum MIXED_DATA_TYPE {
  CASE = 'CASE',
  FILE = 'FILE',
  FOLDER = 'FOLDER'
}

// eslint-disable-next-line no-shadow
export enum MESSAGE_TARGET {
  PERSONAL = 'PERSONAL',
  GROUP = 'GROUP'
}

// eslint-disable-next-line no-shadow
export enum APPLICATION_SETTINGS_TYPE {
  CONTACT_NETWORKING_FEATURE = 'CONTACT_NETWORKING_FEATURE',
  SHOW_PUBLIC_CASES_FEED = 'SHOW_PUBLIC_CASES_FEED',
  SHOW_PUBLIC_CASES_TOGGLE = 'SHOW_PUBLIC_CASES_TOGGLE',
  INSTAGRAM_SHARE = 'INSTAGRAM_SHARE',
}

// eslint-disable-next-line no-shadow
export enum GROUP_USER_STATUS {
  ADMIN = 'ADMIN',
  USER = 'USER',
  OWNER = 'OWNER'
}

// eslint-disable-next-line no-shadow
export enum GROUP_TYPE {
  PUBLIC_OPEN = 'PUBLIC_OPEN',
  PRIVATE = 'PRIVATE',
}

// eslint-disable-next-line no-shadow
export enum FOLDER_SETTINGS_POP_UP_SWITCHER {
  DELETE, MOVE, SHARE, RENAME, SETTINGS, INFO
}

// eslint-disable-next-line no-shadow
export enum MESSAGE_SHARED_ITEM_TYPES {
  CASE_TYPE = 'CASE_TYPE',
  FILE_TYPE = 'FILE_TYPE',
  PHOTO_TYPE = 'PHOTO_TYPE',
  FOLDER_TYPE = 'FOLDER_TYPE'
}

// eslint-disable-next-line no-shadow
export enum MESSAGE_ATTACHMENT_TYPE {
  CASE = 'CASE',
  MEDIA = 'MEDIA',
}

// eslint-disable-next-line no-shadow
export enum MESSAGE_RECEIVER {
  GROUP = 'GROUP',
  CONTACT = 'CONTACT'
}

// eslint-disable-next-line no-shadow
export enum PHOTO_SIZES {
  SM = 66,
  MD = 175,
  LG = 200,
}

// eslint-disable-next-line no-shadow
export enum PHOTO_VIEW_TYPE {
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
  THUMB = 'thumb',
  HMED = 'HMED',
  HSML = 'HSML',
  ORIG = 'ORIG',
  WLRG = 'WLRG',
  WHMED = 'WHMED',
  WHSML = 'WHSML',
}

// eslint-disable-next-line no-shadow
export enum PERFORMANCE_MONITORING_STEPS {
  VUE_INSTANCE_MOUNTED = 'VUE_INSTANCE_MOUNTED',
  FIRST_PAGE_MOUNTED_LOGIN = 'FIRST_PAGE_MOUNTED_LOGIN',
  FIRST_PAGE_MOUNTED_WELCOME = 'FIRST_PAGE_MOUNTED_WELCOME',
}

// eslint-disable-next-line no-shadow
export enum UPLOAD_PLACES {
  DIALOG, DIALOG_PHOTO, FOLDER, FOLDER_PHOTO, CASE, CASE_PHOTO, PHOTO, MIXED, MIXED_PHOTO, PROFILE_PHOTO
}

// eslint-disable-next-line no-shadow
export enum PHOTO_VIEW_LAYOUT {
  GRID_LABEL, GRID, LIST
}

// eslint-disable-next-line no-shadow
export enum CASE_CREATION_POP_UP_SWITCHER {
  UPLOAD_PHOTOS, UPLOAD_FILES, ADD_PHOTOS, ADD_FILES, NONE, CANCEL
}

// eslint-disable-next-line no-shadow
export enum UPLOAD_SOURCE {
  PHONE_CAMERA = 'PHONE_CAMERA', PHONE_LIBRARY = 'PHONE_LIBRARY', DESKTOP = 'DESKTOP'
}

// eslint-disable-next-line no-shadow
export enum MESSAGE_CATEGORY {
  DIRECT_MESSAGING = 'DIRECT_MESSAGING',
  GROUP_MESSAGING = 'GROUP_MESSAGING'
}

// eslint-disable-next-line no-shadow
export enum MOCK_MESSAGE_STATUS {
  SENDING = 'SENDING',
  ERROR = 'ERROR'
}

// eslint-disable-next-line no-shadow
export enum SHARE_SETTINGS {
  RESHARE_ALLOWED = 'RESHARE_ALLOWED',
  RESHARE_DISABLED = 'RESHARE_DISABLED',
  ALLOW_SAVE = 'ALLOW_SAVE',
  DISABLE_SAVE = 'DISABLE_SAVE',
  DISPLAY_ATTRIBUTION = 'DISPLAY_ATTRIBUTION',
  NOT_DISPLAY_ATTRIBUTION = 'NOT_DISPLAY_ATTRIBUTION',
}

// eslint-disable-next-line no-shadow
export enum HEALTHCARE {
  MEDICAL,
  DENTAL,
  NURSING,
  ALLIED_HEALTH,
  NATUROPATHY,
  AUDIOLOGY,
  PHARMACY,
  VETERINARY,
  OTHER,
}

// eslint-disable-next-line no-shadow
export enum STUDY_TYPE {
  STUDENT = 'STUDENT',
  RESIDENT = 'RESIDENT',
}

// eslint-disable-next-line no-shadow
export enum VERIFICATION_STATUS {
  FAILED = 'VERIFICATION_FAILED',
  SUCCESS = 'VERIFICATION_SUCCESS',
}

// eslint-disable-next-line no-shadow
export enum CHOOSER_TYPE {
  ALL = 'all',
  CAMERA_IMAGE = 'camera-image',
  CAMERA_VIDEO = 'camera-video',
  FILE = 'file',
  GALLERY = 'gallery',
}
